// Supermove
import {gql} from '@supermove/graphql';
import {withFragment} from '@supermove/utils';

import JobUserForm from './JobUserForm';

const newFromJob = withFragment(
  (job, {userId, appInstallId}) => ({
    jobId: (job as any).id,
    userId,
    appInstallId,
    jobUserForms: (job as any).jobUsers.map((jobUser: any) => JobUserForm.edit(jobUser)),
  }),
  gql`
    ${JobUserForm.edit.fragment}

    fragment JobConfirmCrewForm_newFromJob on Job {
      id
      jobUsers: activeJobUsers {
        id
        ...JobUserForm_edit
      }
    }
  `,
);

const toForm = ({jobId, userId, appInstallId, jobUserForms}: any) => ({
  jobId,
  userId,
  appInstallId,
  jobUserForms: jobUserForms.map((jobUserForm: any) => JobUserForm.toForm(jobUserForm)),
});

const toMutation = ({jobId, userId, appInstallId, jobUserForms}: any) => ({
  jobId,
  userId,
  appInstallId,
  jobUserForms: jobUserForms.map((jobUserForm: any) => JobUserForm.toMutation(jobUserForm)),
});

const JobConfirmCrewForm = {
  newFromJob,
  toForm,
  toMutation,
};

export default JobConfirmCrewForm;
